export interface Setting {
    id: number;
    configKey: string;
    configValue: string;
    dateChanged: string;
    dateUpdated: string;
    dateDeleted?: string;
}

export enum ConfigKeys {
    DefaultReplyTo = 'DEFAULT_REPLY_TO',
    SFConsumerKey = "SF_CONSUMER_KEY",
    SFConsumerSecret = "SF_CONSUMER_SECRET",
    SFRefreshToken = "SF_REFRESH_TOKEN",
    SFBaseUrl = "SF_BASE_URL",
}
export enum Languages {
    English = 'en',
    French = 'fr',
    ChineseSimplified = 'zh-CN',
    ChineseTraditional = 'zh-TW',
    Spanish = 'es',
    Russian = 'ru',
    Malay = 'my',
    Swahili = 'sw',
    Nepali = 'ne',
    Khmer = 'km',
    Vietnamese = 'vi',
    Portuguese = 'pt',
    HaitianCreole = 'ht',
    Ewe = 'ee',
    Lingala = 'ln',
}

export interface EmployerInfo {
    name: string;
    gPlaces?: any;
    location: any;
}

export interface CampaignData {
    replyEmail: string;
    employerName: string;
    employerLocation: any;
    employers: EmployerInfo[];
    allowOther: boolean;
    jobTitles: string[];
    allowOtherJobTitles: boolean;
}

export interface Campaign {
    id: number;
    employerNames?: EmployerInfo[];
    replyEmail?: string;
    dateCreated: string;
    dateDeleted?: string;
    dateUpdates: string;
    description?: string;
    path: string;
    region: string;
    title: string;
    type: string;
    totalSignups: number;
    salesforceEnabled: boolean;
    salesforceEmployerLocations: SalesforceEmployerLocation[];
    data: CampaignData;
}

export enum JoinSurveyQuestionType {
    MultiChoice,
    SingleChoice
}

export interface FilterSelectionRequest {
    campaigns: string[];
    regions: string[];
    local: string;
    showOtherEmployers: boolean;
}

export interface SalesforceEmployerLocation {
    name: string;
    salesforceId: string;
    id: number;
}

export interface WebhookEndpoint {
    id: number;
    active: boolean;
    weblinkId: string;
    endpointUrl: string;
    eventType: WebhookEndpointEventType;
    dateChanged: string;
    dateUpdated: string;
    dateDeleted?: string;
    timesInvoked: number;
    dependencyLocked: boolean;
    dependentService: string;
}
export enum WebhookEndpointEventType {
    CampaignUserSignup
}

export interface ResendReplyToRequest {
    recipients: string[];
    signupIds: number[];
}
export enum Region {
    Region1 = 'REGION_1',
    Region2 = 'REGION_2',
    Region4 = 'REGION_4',
    Region5 = 'REGION_5',
    Region6 = 'REGION_6',
    Region7 = 'REGION_7',
    Region8 = 'REGION_8',
    Canada = 'CANADA',
    CW = 'CW',
    DW = 'DW',
    Intl = 'INTL',
}

export interface User {
    userName: string;
    email: string;
    phoneNumber: string;
    disabled: boolean;
    regions: Region[];
    campaignIds: number[];
    roles: string[];
}

export interface TokenRevocationRequest {
    user: string;
}

export interface ApproveUserRequest {
    user: string;
}

export enum Role {
    Admin = 'Admin',
    CampaignManager = 'CampaignManager',
}
